/* Chinese Zodiac V2 engine — faithful runtime for the design markup.
   Live adaptations: theme header/footer replace the design's own, the free
   insight card upgrades from the design's deterministic templates to a short
   audited DeepSeek line from /api/chinese-zodiac, the current zodiac year is
   computed instead of hardcoded, and checkout runs on the proven shared rail. */
(function () {
  'use strict';
  if (!document.querySelector('[data-zc]')) return;

  var PAGE = '/pages/chinese-zodiac-calculator';
  var API_BASE = 'https://reading.deckaura.com/api/chinese-zodiac';
  var RAIL_TIERS = ['essential', 'deeper', 'indepth'];

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var CNY = ('0220,0208,0128,0216,0205,0124,0213,0202,0123,0210,' +
    '0130,0217,0206,0126,0214,0204,0124,0211,0131,0219,' +
    '0208,0127,0215,0205,0125,0213,0202,0122,0210,0129,' +
    '0217,0206,0127,0214,0203,0124,0212,0131,0218,0208,' +
    '0128,0215,0205,0125,0213,0202,0121,0209,0130,0217,' +
    '0206,0127,0215,0203,0123,0211,0131,0218,0207,0128,' +
    '0216,0205,0125,0213,0202,0220,0209,0129,0217,0206,' +
    '0127,0215,0204,0123,0210,0131,0219,0207,0128,0216,' +
    '0205,0124,0212,0201,0122,0209,0129,0218,0207,0126,' +
    '0214,0203,0123,0210,0131,0219,0208,0128,0216,0205,' +
    '0125,0212,0201,0122,0210,0129,0217,0206,0126,0213,' +
    '0203,0123').split(',');

  var AN = [
    { n: 'Rat', c: '鼠', line: 'read conditions early and move when the odds turn', gift: 'timing and quick reassessment', fr: 'keeps a private calculation running' },
    { n: 'Ox', c: '牛', line: 'build slowly and rarely reopen a decision', gift: 'steadiness and follow-through', fr: 'refuses to reopen a settled decision' },
    { n: 'Tiger', c: '虎', line: 'start first and correct on the way', gift: 'momentum and courage', fr: 'moves before the other person is ready' },
    { n: 'Rabbit', c: '兔', line: 'keep the peace by managing distance', gift: 'tact and emotional reading', fr: 'manages distance instead of naming the problem' },
    { n: 'Dragon', c: '龍', line: 'set the standard and expect the room to rise to it', gift: 'ambition and a raised standard', fr: 'takes over the moment the pace drops' },
    { n: 'Snake', c: '蛇', line: 'watch long, commit rarely and revise quietly', gift: 'depth and pattern recognition', fr: 'withholds the conclusion until it is final' },
    { n: 'Horse', c: '馬', line: 'need forward motion, and give loyalty only where there is room', gift: 'energy and open direction', fr: 'needs space the moment it feels held' },
    { n: 'Goat', c: '羊', line: 'protect harmony while holding a private line', gift: 'care and atmosphere', fr: 'stays past its own boundary, then withdraws' },
    { n: 'Monkey', c: '猴', line: 'find the sideways route when the front door is shut', gift: 'invention and second routes', fr: 'changes the plan without announcing it' },
    { n: 'Rooster', c: '雞', line: 'say the precise thing, because standards are how you show care', gift: 'precision and honesty', fr: 'corrects when reassurance was needed' },
    { n: 'Dog', c: '狗', line: 'watch closely, weigh fairness, and forgive slowly', gift: 'loyalty and fairness', fr: 'tests trust long after it was earned' },
    { n: 'Pig', c: '豬', line: 'deal plainly and give first', gift: 'generosity and plain dealing', fr: 'gives first and counts the cost later' }
  ];
  var EL = [
    { n: 'Metal', hex: '#A9ADB5', ink: '#D5D8DE', mod: 'makes you more selective and internally uncompromising than the standard description suggests' },
    { n: 'Water', hex: '#465E7D', ink: '#A9BFE0', mod: 'makes you adaptive and indirect, so you move around obstacles rather than through them' },
    { n: 'Wood', hex: '#657457', ink: '#BFD0AC', mod: 'keeps you expanding, always pushing the plan one step past its current size' },
    { n: 'Fire', hex: '#A95248', ink: '#EBA79C', mod: 'raises the tempo and the visibility of everything you do' },
    { n: 'Earth', hex: '#A98255', ink: '#DDB98A', mod: 'slows you down and makes you build for the long term' }
  ];
  var INTENTS = [
    { k: 'self', title: 'Understand myself', desc: 'Decode a pattern in your personality, choices or emotional responses.', dot: '14px', radius: '50%' },
    { k: 'love', title: 'A relationship', desc: 'Explore the rhythm, attraction and friction between two people.', dot: '20px', radius: '50%' },
    { k: 'career', title: 'Career and money', desc: 'Understand your natural work style, decisions and financial patterns.', dot: '12px', radius: '2px' },
    { k: 'year', title: 'My next 12 months', desc: 'See how your personal combination meets the current zodiac year.', dot: '22px', radius: '50%' }
  ];
  var CHIPS = {
    self: { q: 'Which pattern would you most like to understand?', items: ['Confidence', 'Boundaries', 'Overthinking', 'Motivation', 'Relationships', 'Life direction'] },
    love: { q: 'What feels unresolved between you?', items: ['We keep repeating one argument', 'One of us wants more closeness', 'Communication has gone quiet', 'Should I stay or leave', 'It has not started yet', 'Recently ended'] },
    career: { q: 'What is the decision in front of you?', items: ['Changing jobs', 'Starting a business', 'Workplace conflict', 'Money direction', 'Leadership', 'Feeling stuck'] },
    year: { q: 'What matters most in the months ahead?', items: ['Love', 'Career', 'Money', 'Family', 'Personal growth'] }
  };
  var PKG = {
    self: [
      { t: 'My Zodiac Key', p: '$5.99', promise: 'Decode one pattern that matters right now.', b: ['Your animal, element and polarity read as one', 'One focused question', 'Your strongest advantage and hidden blind spot', 'One practical next step'], cta: 'Unlock My Zodiac Key', w: 'approx. 450–600 words' },
      { t: 'My Alignment Blueprint', p: '$9.99', promise: 'See what is really shaping the situation.', b: ['Everything in My Zodiac Key', 'Chinese and Western zodiac synthesis', 'Hidden tension and balancing influence', 'Three practical actions'], cta: 'Build My Alignment Blueprint', w: 'approx. 750–950 words' },
      { t: 'My 12-Month Zodiac Map', p: '$16.99', promise: 'Turn your result into a plan for the months ahead.', b: ['Everything in My Alignment Blueprint', 'Your sign against the current zodiac year', 'Love, career and money timing themes', 'Opportunity and caution windows', 'A practical 30-day starting plan'], cta: 'Map My Next 12 Months', w: 'approx. 1,250–1,500 words' }
    ],
    love: [
      { t: 'My Relationship Pattern', p: '$5.99', promise: 'Understand how you behave when closeness is at stake.', b: ['How your combination behaves in relationships', 'The condition that triggers distance or pursuit', 'Your strongest relational advantage', 'One practical next step'], cta: 'Unlock My Relationship Pattern', w: 'approx. 450–600 words' },
      { t: 'Our Compatibility Blueprint', p: '$9.99', promise: 'Understand the attraction, tension and communication rhythm between you.', b: ['Both zodiac combinations compared', 'Attraction and friction pattern', 'Communication and repair style', 'Three practical relationship actions'], cta: 'Build Our Blueprint', w: 'approx. 750–950 words' },
      { t: 'Our 12-Month Relationship Map', p: '$16.99', promise: 'Compatibility, timing and a plan for the year ahead.', b: ['Everything in Our Compatibility Blueprint', 'How the current zodiac year meets both charts', 'Closeness and distance windows', 'Repair and decision timing', 'A practical 30-day starting plan'], cta: 'Map Our Next 12 Months', w: 'approx. 1,250–1,500 words' }
    ],
    career: [
      { t: 'My Career Pattern', p: '$5.99', promise: 'See how you actually make work decisions.', b: ['Work style, authority and risk read from your combination', 'The decision on your mind', 'Your strongest professional advantage', 'One practical next step'], cta: 'Unlock My Career Pattern', w: 'approx. 450–600 words' },
      { t: 'My Work and Money Blueprint', p: '$9.99', promise: 'Understand the structure behind the decision.', b: ['Everything in My Career Pattern', 'Chinese and Western zodiac synthesis', 'Money strengths and weak tendencies', 'Three concrete moves'], cta: 'Build My Work Blueprint', w: 'approx. 750–950 words' },
      { t: 'My 12-Month Career Map', p: '$16.99', promise: 'Timing for the moves you are considering.', b: ['Everything in My Work and Money Blueprint', 'Your sign against the current zodiac year', 'Visibility and review periods', 'Act, wait or prepare guidance', 'A practical 30-day starting plan'], cta: 'Map My Career Year', w: 'approx. 1,250–1,500 words' }
    ],
    year: [
      { t: 'This Year’s Main Influence', p: '$5.99', promise: 'How the current zodiac year meets your combination.', b: ['Your combination against the current zodiac year', 'The single strongest theme for you', 'What this year asks you to drop', 'One practical next step'], cta: 'Unlock This Year’s Influence', w: 'approx. 450–600 words' },
      { t: 'My Next 90 Days', p: '$9.99', promise: 'A near-term read you can actually act on.', b: ['Everything in This Year’s Main Influence', 'Chinese and Western zodiac synthesis', 'Three months in expansion, review and caution terms', 'Three practical actions'], cta: 'Build My 90-Day Read', w: 'approx. 750–950 words' },
      { t: 'My Full 12-Month Map', p: '$16.99', promise: 'The whole year in four periods, with a starting plan.', b: ['Everything in My Next 90 Days', 'Four periods across love, work, money and energy', 'Three opportunity windows', 'Three triggers to watch', 'A practical 30-day starting plan'], cta: 'Map My Next 12 Months', w: 'approx. 1,250–1,500 words' }
    ]
  };

  /* ------------ zodiac math (design port) ------------ */
  function sign(y, m, d) {
    var s2 = CNY[y - 1920] || '0205';
    var cm = +s2.slice(0, 2), cd = +s2.slice(2);
    var before = (m < cm) || (m === cm && d < cd);
    var zy = before ? y - 1 : y;
    var a = AN[(((zy - 1900) % 12) + 12) % 12];
    var e = EL[Math.floor(((((zy - 1900) % 10) + 10) % 10) / 2)];
    var pol = zy % 2 === 0 ? 'Yang' : 'Yin';
    return { a: a, e: e, pol: pol, zy: zy, cm: cm, cd: cd, before: before, full: pol + ' ' + e.n + ' ' + a.n };
  }
  function rhythmOf(i, j) {
    var dd = (((i - j) % 12) + 12) % 12;
    if ((i + j) % 12 === 1) return 'Strong';
    if (dd === 4 || dd === 8) return 'Strong';
    if (dd === 6) return 'Challenging';
    if (dd === 3 || dd === 9) return 'Challenging';
    return 'Mixed';
  }
  var WESTERN = [['Capricorn', 119], ['Aquarius', 218], ['Pisces', 320], ['Aries', 419], ['Taurus', 520], ['Gemini', 620], ['Cancer', 722], ['Leo', 822], ['Virgo', 922], ['Libra', 1022], ['Scorpio', 1121], ['Sagittarius', 1221], ['Capricorn', 1231]];
  function westernSign(m, d) {
    var key = m * 100 + d;
    for (var i = 0; i < WESTERN.length; i += 1) { if (key <= WESTERN[i][1]) return WESTERN[i][0]; }
    return 'Capricorn';
  }
  var now = new Date();
  var CZ = sign(Math.min(2031, Math.max(1920, now.getFullYear())), now.getMonth() + 1, now.getDate());
  var CZ_NAME = CZ.e.n + ' ' + CZ.a.n;
  PKG.year[0].b[0] = 'Your combination against the ' + CZ_NAME + ' year';

  /* ------------ state ------------ */
  var s = {
    m: '', d: '', y: '', err: '', phase: 'input', editing: false,
    intent: null, chip: null,
    pm: '', pd: '', py: '', partner: null,
    pkg: 1, sample: false, share: false, method: false,
    compA: 'Goat', compB: 'Horse',
    w: window.innerWidth, live: '',
    server: null, busy: false, readingId: '', insightKey: '', fetches: 0
  };
  var calcTimer = null, insightTimer = null;

  function mySign() {
    return (s.m && s.d && s.y) ? sign(+s.y, +s.m, +s.d) : null;
  }
  function tone(r) {
    return r === 'Strong' ? { bg: 'rgba(127,175,149,0.12)', bd: 'rgba(127,175,149,0.45)', c: '#7FAF95', lbg: 'rgba(94,122,102,0.10)', lbd: 'rgba(94,122,102,0.35)', lc: '#4E6A56' }
      : r === 'Challenging' ? { bg: 'rgba(192,140,134,0.12)', bd: 'rgba(192,140,134,0.45)', c: '#C08C86', lbg: 'rgba(154,94,88,0.10)', lbd: 'rgba(154,94,88,0.32)', lc: '#8A544E' }
      : { bg: 'rgba(201,169,106,0.12)', bd: 'rgba(201,169,106,0.42)', c: '#C9A96A', lbg: 'rgba(154,127,69,0.10)', lbd: 'rgba(154,127,69,0.30)', lc: '#7E6737' };
  }
  function rgba(hex, aVal) {
    return 'rgba(' + parseInt(hex.slice(1, 3), 16) + ',' + parseInt(hex.slice(3, 5), 16) + ',' + parseInt(hex.slice(5, 7), 16) + ',' + aVal + ')';
  }
  function freeCopy(sg, intent) {
    var el = sg.e, an = sg.a;
    if (intent === 'self') return {
      insight: 'Your ' + el.n + ' ' + an.n + ' pattern ' + an.fr + '. It is rarely the first decision that costs you, it is the one made after holding the situation too long.',
      next: 'Your full reading traces where that pattern comes from and what actually interrupts it.'
    };
    if (intent === 'love') return {
      insight: 'Your ' + el.n + ' ' + an.n + ' pattern ' + an.fr + '. To the other person this can look sudden, even when it has been building quietly for some time.',
      next: 'Your full compatibility reading identifies where this pattern meets the other person’s zodiac combination.'
    };
    if (intent === 'career') return {
      insight: 'Your ' + el.n + ' ' + an.n + ' pattern ' + an.fr + '. At work this usually shows up as a decision you have already made privately but have not said out loud.',
      next: 'Your full reading shows how that plays against authority, risk and money.'
    };
    return {
      insight: 'Your ' + el.n + ' ' + an.n + ' combination meets a ' + CZ_NAME + ' year: fast, visible and rewarding to early movement, punishing to drift.',
      next: 'Your full map shows which months open for you and which ones ask you to wait.'
    };
  }

  /* ------------ compute (design renderVals portu) ------------ */
  function computeVals() {
    var compact = s.w < 780;
    var has = s.phase === 'result';
    var done = has && !s.editing;
    var sg = mySign();
    var el = sg ? sg.e : EL[0];
    var accent = el.hex;
    var intent = s.intent;
    var pkgList = PKG[intent || 'self'];
    var chipSet = intent ? CHIPS[intent] : null;
    var partner = s.partner;

    var free = '', freeNext = '';
    if (sg && intent) {
      if (s.server && s.server.key === s.insightKey && s.server.insight) {
        free = s.server.insight;
        freeNext = s.server.next || freeCopy(sg, intent).next;
      } else {
        var fc = freeCopy(sg, intent);
        free = fc.insight; freeNext = fc.next;
      }
    }

    var ai = 7, bi = 6;
    for (var x = 0; x < 12; x += 1) { if (AN[x].n === s.compA) ai = x; if (AN[x].n === s.compB) bi = x; }
    var compR = rhythmOf(ai, bi);
    var cTone = tone(compR);
    var stickyOn = compact && done && !!intent && !s.sample && !s.share;

    var vals = {
      live: s.live,
      sealOn: !done,
      calcOpen: !done || s.editing,
      compactBar: done && !s.editing,
      m: s.m, d: s.d, y: s.y,
      err: s.err, errOn: !!s.err,
      busy: s.phase === 'calculating',
      ctaLabel: s.phase === 'calculating' ? 'Calculating your sign' : (has ? 'Update my result' : 'Reveal my Chinese zodiac'),
      methodOpen: s.method, methodRot: s.method ? '180deg' : '0deg',
      dobText: (s.m && s.d && s.y) ? MONTHS[+s.m - 1] + ' ' + s.d + ', ' + s.y : '',

      hasResult: done,
      aura: rgba(accent, 0.18),
      artBorder: rgba(accent, 0.35),
      plateGlow: rgba(accent, 0.30),
      char: sg ? sg.a.c : '',
      full: sg ? sg.full : '',
      animal: sg ? sg.a.n : '', element: el.n, polarity: sg ? sg.pol : '',
      elHex: el.hex,
      elInk: el.ink,
      elBorder: rgba(el.hex, 0.55),
      bornLine: sg ? ('Born ' + MONTHS[+s.m - 1] + ' ' + s.d + ', ' + s.y + ' · zodiac year ' + sg.zy) : '',
      insight: sg ? ('You ' + sg.a.line + '. Your ' + el.n + ' influence ' + el.mod + ', and your ' + sg.pol + ' polarity ' + (sg.pol === 'Yin' ? 'resolves it inwardly, which is why a shift can look sudden from the outside.' : 'pushes it outward, which is why a shift is visible before it is finished.')) : '',
      cutoffOn: !!(sg && sg.before),
      cutoffText: sg ? ('You were born before Chinese New Year on ' + MONTHS[sg.cm - 1] + ' ' + sg.cd + ', ' + s.y + ', so your sign comes from the ' + sg.zy + ' zodiac year, not ' + s.y + '.') : '',
      shareLine: sg ? ('Element ' + el.n + ' · ' + sg.pol + ' · ' + sg.a.gift + '. Meeting a ' + CZ_NAME + ' year.') : '',

      steps: [
        { label: 'Result', mark: '✓', bg: 'rgba(201,169,106,0.16)', border: 'rgba(201,169,106,0.5)', numColor: '#C9A96A', color: '#C9A96A', lineOn: 'block' },
        { label: 'Focus', mark: intent ? '✓' : '2', bg: intent ? 'rgba(201,169,106,0.16)' : 'rgba(245,240,232,0.05)', border: intent ? 'rgba(201,169,106,0.5)' : 'rgba(245,240,232,0.16)', numColor: intent ? '#C9A96A' : '#D6D2E0', color: intent ? '#C9A96A' : '#E4E0EC', lineOn: 'block' },
        { label: 'Report', mark: '3', bg: 'rgba(245,240,232,0.05)', border: 'rgba(245,240,232,0.14)', numColor: '#D6D2E0', color: intent ? '#E4E0EC' : '#D6D2E0', lineOn: 'none' }
      ],
      intents: INTENTS.map(function (it) {
        var on = intent === it.k;
        return {
          title: it.title, desc: it.desc, checked: on, selected: on,
          dotSize: it.dot, dotRadius: it.radius,
          border: on ? 'rgba(201,169,106,0.55)' : 'rgba(245,240,232,0.10)',
          bg: on ? '#171D34' : '#11162A',
          lift: on ? 'translateY(-3px)' : 'none',
          iconBorder: on ? 'rgba(201,169,106,0.55)' : 'rgba(245,240,232,0.22)',
          iconInner: on ? 'rgba(201,169,106,0.8)' : 'rgba(245,240,232,0.4)'
        };
      }),
      subOn: !!chipSet,
      subTitle: chipSet ? chipSet.q : '',
      chips: chipSet ? chipSet.items.map(function (l) {
        var on = s.chip === l;
        return { label: l, on: on,
          bg: on ? 'rgba(201,169,106,0.14)' : 'rgba(245,240,232,0.04)',
          border: on ? 'rgba(201,169,106,0.6)' : 'rgba(245,240,232,0.14)',
          color: on ? '#E7D6AE' : '#D6D2E0' };
      }) : [],

      partnerOn: intent === 'love',
      pm: s.pm, pd: s.pd, py: s.py,
      partnerResOn: !!partner,
      pFull: partner ? partner.full : '',
      rhythm: partner && sg ? rhythmOf(AN.indexOf(sg.a), AN.indexOf(partner.a)) : '',
      rhythmBg: partner && sg ? tone(rhythmOf(AN.indexOf(sg.a), AN.indexOf(partner.a))).bg : '',
      rhythmBorder: partner && sg ? tone(rhythmOf(AN.indexOf(sg.a), AN.indexOf(partner.a))).bd : '',
      rhythmColor: partner && sg ? tone(rhythmOf(AN.indexOf(sg.a), AN.indexOf(partner.a))).c : '',
      harmony: partner && sg ? (sg.a.n + ' brings ' + sg.a.gift + '; ' + partner.a.n + ' brings ' + partner.a.gift + '.') : '',
      friction: partner && sg ? (sg.a.n + ' ' + sg.a.fr + ', while ' + partner.a.n + ' ' + partner.a.fr + '.') : '',

      offerOn: done && !!intent,
      offerTitle: 'Choose your report',
      freeInsight: free, freeInsightNext: freeNext,
      pkgCols: compact ? '1fr' : 'repeat(3,1fr)',
      pkgs: pkgList.map(function (pk, i) {
        var sel = s.pkg === i, mid = i === 1;
        return {
          title: pk.t, promise: pk.promise, price: pk.p, cta: pk.cta, words: pk.w,
          bullets: pk.b.map(function (t) { return { t: t }; }),
          badgeOn: mid, badge: 'BEST BALANCE',
          pad: mid && !compact ? '30px' : '26px',
          titleSize: mid && !compact ? '25px' : '22px',
          priceSize: mid && !compact ? '38px' : '32px',
          bg: sel ? '#171D34' : '#11162A',
          border: sel ? 'rgba(201,169,106,0.55)' : 'rgba(245,240,232,0.10)',
          lift: mid && !compact ? 'translateY(-14px)' : 'none',
          shadow: mid ? '0 1px 2px rgba(8,11,22,0.4),0 26px 70px rgba(0,0,0,0.45)' : 'none',
          checked: sel, radioMark: sel ? '✓' : '',
          radioBg: sel ? '#C9A96A' : 'transparent',
          radioBorder: sel ? '#C9A96A' : 'rgba(245,240,232,0.28)',
          featuresOn: !compact || sel,
          ctaBg: sel ? '#C9A96A' : 'transparent',
          ctaBorder: sel ? '#C9A96A' : 'rgba(245,240,232,0.20)',
          ctaColor: sel ? '#12100A' : '#E4E0EC'
        };
      }),
      sampleTitle: pkgList[1].t,
      sampleOn: s.sample,
      shareOn: s.share,

      compA: s.compA, compB: s.compB,
      compRhythm: 'Natural rhythm · ' + compR,
      compBg: cTone.lbg, compBorder: cTone.lbd, compColor: cTone.lc,
      compHarmony: AN[ai].n + ' brings ' + AN[ai].gift + '; ' + AN[bi].n + ' brings ' + AN[bi].gift + '.',
      compFriction: AN[ai].n + ' ' + AN[ai].fr + ', while ' + AN[bi].n + ' ' + AN[bi].fr + '.',

      stickyOn: stickyOn,
      stickyTitle: pkgList[s.pkg].t,
      stickyPrice: pkgList[s.pkg].p
    };
    return vals;
  }

  /* ------------ renderer (paylasilan data-rv2 cekirdegi) ------------ */
  function resolvePath(vals, item, path) {
    if (item != null && typeof item !== 'object' && path.indexOf('.') === -1) return item;
    if (item && path.indexOf('.') > -1) {
      var key = path.split('.').slice(1).join('.');
      var vv = item;
      key.split('.').forEach(function (p) { vv = vv == null ? vv : vv[p]; });
      if (vv !== undefined) return vv;
    }
    var out = vals;
    path.split('.').forEach(function (p) { out = out == null ? out : out[p]; });
    return out;
  }
  function applyBindings(scope, vals, item) {
    function skip(elm) { return !item && elm.closest('[data-rv2-item]'); }
    scope.querySelectorAll('[data-rv2-bind]').forEach(function (elm) {
      if (skip(elm)) return;
      var vv = resolvePath(vals, item, elm.getAttribute('data-rv2-bind'));
      elm.textContent = vv == null ? '' : String(vv);
    });
    scope.querySelectorAll('*').forEach(function (elm) {
      if (skip(elm)) return;
      Array.prototype.slice.call(elm.attributes).forEach(function (attr) {
        if (attr.name.indexOf('data-rv2-attr-') !== 0) return;
        var real = attr.name.slice('data-rv2-attr-'.length);
        var value = attr.value.replace(/%%([\w.]+)%%/g, function (_, key) {
          var vv = resolvePath(vals, item, key);
          return vv == null ? '' : String(vv);
        });
        if (real === 'value') { if (elm.value !== value) elm.value = value; }
        else if (real === 'disabled' || real === 'aria-disabled') {
          if (value && value !== 'false') elm.setAttribute(real, real === 'disabled' ? '' : 'true');
          else elm.removeAttribute(real);
        }
        else elm.setAttribute(real, value);
      });
    });
    scope.querySelectorAll('[data-rv2-ifitem]').forEach(function (elm) {
      if (skip(elm)) return;
      var key = elm.getAttribute('data-rv2-ifitem');
      var neg = key.charAt(0) === '!';
      var vv = resolvePath(vals, item, neg ? key.slice(1) : key);
      elm.style.display = (neg ? !vv : !!vv) ? 'contents' : 'none';
    });
    if (item != null) {
      scope.querySelectorAll('[data-rv2-list]').forEach(function (h) {
        var nmr = h.getAttribute('data-rv2-list');
        if (nmr.indexOf('.') === -1) return;
        var sub = resolvePath(vals, item, nmr.replace(/\d+$/, ''));
        if (sub && sub.length) instantiateList(h, sub, vals);
      });
    }
  }
  var TPL = {};
  document.querySelectorAll('template[data-rv2-tpl]').forEach(function (t) {
    TPL[t.getAttribute('data-rv2-tpl')] = t;
  });
  function instantiateList(host, items, vals) {
    var name = host.getAttribute('data-rv2-list').split('.').pop();
    var tpl = TPL[name] || TPL[name.replace(/\d+$/, '')];
    if (!tpl) return;
    host.style.display = 'contents';
    while (host.firstChild) host.removeChild(host.firstChild);
    items.forEach(function (item, idx) {
      var node = tpl.content.cloneNode(true);
      var holder = document.createElement('div');
      holder.style.display = 'contents';
      holder.setAttribute('data-rv2-item', name.replace(/\d+$/, ''));
      holder.setAttribute('data-rv2-idx', String(idx));
      holder.appendChild(node);
      applyBindings(holder, vals, item);
      host.appendChild(holder);
    });
  }
  function render() {
    var vals = computeVals();
    document.querySelectorAll('[data-rv2-if]').forEach(function (elm) {
      if (elm.closest('[data-rv2-item]')) return;
      var key = elm.getAttribute('data-rv2-if');
      var neg = key.charAt(0) === '!';
      var vv = vals[neg ? key.slice(1) : key];
      elm.style.display = (neg ? !vv : !!vv) ? 'contents' : 'none';
    });
    document.querySelectorAll('[data-rv2-list]').forEach(function (host) {
      if (host.closest('[data-rv2-item]')) return;
      var name = host.getAttribute('data-rv2-list');
      instantiateList(host, vals[name] || vals[name.replace(/\d+$/, '')] || [], vals);
    });
    applyBindings(document, vals, null);
    document.body.classList.toggle('zc-sticky-on', !!vals.stickyOn);
    var lv = document.querySelector('[data-zc-live]');
    if (lv && lv.textContent !== s.live) lv.textContent = s.live;
  }

  /* ------------ helpers ------------ */
  function track(name, data) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({ page_funnel: 'zc-v2' }, data || {})); } catch (_) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (_) {}
  }
  function visitorId() {
    var key = 'deckaura_visitor_v1';
    try {
      var existing = localStorage.getItem(key);
      if (existing && /^[a-zA-Z0-9_-]{16,96}$/.test(existing)) return existing;
      var bytes = new Uint8Array(18); crypto.getRandomValues(bytes);
      var next = 'v_' + Array.prototype.map.call(bytes, function (x2) { return x2.toString(16).padStart(2, '0'); }).join('');
      localStorage.setItem(key, next);
      return next;
    } catch (_) { return 'v_' + Date.now().toString(16) + Math.random().toString(36).slice(2, 10); }
  }
  function scrollScreen(label, offset) {
    var elm = document.querySelector('[data-screen-label="' + label + '"]');
    if (!elm) return;
    try {
      window.scrollTo({ top: elm.getBoundingClientRect().top + window.pageYOffset - (offset || 76), behavior: 'smooth' });
    } catch (_) {}
  }
  function dobText() {
    return (s.m && s.d && s.y) ? MONTHS[+s.m - 1] + ' ' + s.d + ', ' + s.y : '';
  }
  function intentTitle() {
    for (var i = 0; i < INTENTS.length; i += 1) { if (INTENTS[i].k === s.intent) return INTENTS[i].title; }
    return '';
  }
  function composedQuestion() {
    var chip = s.chip ? s.chip.toLowerCase() : '';
    if (s.intent === 'love') return 'What should I understand about this relationship' + (chip ? ': ' + chip : '') + '?';
    if (s.intent === 'career') return 'What should I understand about my career and money' + (chip ? ': ' + chip : '') + '?';
    if (s.intent === 'year') return 'What should I expect in my next 12 months' + (chip ? ', with focus on ' + chip : '') + '?';
    return 'What should I understand about myself' + (chip ? ', especially ' + chip : '') + '?';
  }

  /* ------------ server insight ------------ */
  function insightKeyNow() {
    return [s.y, s.m, s.d, s.intent || '', s.chip || '', s.partner ? s.partner.full : ''].join('|');
  }
  function scheduleInsight() {
    if (insightTimer) clearTimeout(insightTimer);
    insightTimer = setTimeout(fetchInsight, 900);
  }
  function fetchInsight() {
    var sg = mySign();
    if (!sg || !s.intent || s.phase !== 'result') return;
    var key = insightKeyNow();
    if (s.busy || (s.server && s.server.key === key) || s.fetches >= 4) return;
    s.busy = true;
    s.insightKey = key;
    var body = {
      dob: { y: +s.y, m: +s.m, d: +s.d },
      intent: s.intent,
      chip: s.chip || '',
      partner: s.partner ? { y: +s.py, m: +s.pm, d: +s.pd } : null,
      visitorId: visitorId(),
      readingId: s.readingId
    };
    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ac ? setTimeout(function () { ac.abort(); }, 14000) : 0;
    fetch(API_BASE + '/free-insight', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), signal: ac ? ac.signal : undefined
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        s.fetches += 1;
        if (res.ok && res.data && res.data.insight) {
          s.server = { insight: res.data.insight, next: res.data.next, key: key };
          track('zc_v2_insight_ready', { source: res.data.servedSource, intent: s.intent });
        }
      })
      .catch(function () {})
      .finally(function () {
        if (timer) clearTimeout(timer);
        s.busy = false;
        render();
      });
  }

  /* ------------ checkout rail ------------ */
  function signalString() {
    var sg = mySign();
    if (!sg) return '';
    var out = 'You: ' + sg.full + ' (zodiac year ' + sg.zy + ', born ' + dobText() + ')' +
      '; Element: ' + sg.e.n + '; Polarity: ' + sg.pol +
      '; Western sun sign: ' + westernSign(+s.m, +s.d) +
      '; Focus: ' + intentTitle();
    if (s.chip) out += '; Detail: ' + s.chip;
    if (s.partner) out += '; Partner: ' + s.partner.full + ' (zodiac year ' + s.partner.zy + ', born ' + MONTHS[+s.pm - 1] + ' ' + s.pd + ', ' + s.py + ')' +
      '; Pair rhythm: ' + rhythmOf(AN.indexOf(sg.a), AN.indexOf(s.partner.a));
    out += '; Current zodiac year: ' + CZ.pol + ' ' + CZ_NAME + ' ' + CZ.zy;
    return out;
  }
  function enableRail() {
    var api = window.DeckauraDeepReading;
    var sg = mySign();
    if (!api || typeof api.enable !== 'function' || !sg || !s.intent) return;
    var pk = PKG[s.intent][s.pkg];
    var q = composedQuestion();
    try {
      api.enable({
        type: 'Chinese Zodiac', teaser: false, resultReady: true,
        presentationVariant: 'chinese-zodiac-v2',
        canonicalPage: PAGE, visitorId: visitorId(),
        question: q, readingId: s.readingId,
        curiosityQuestion: 'What your combination does under pressure, and the one move that interrupts it',
        focus: intentTitle(), fixedFocus: 'ChineseZodiac V2 - ' + s.intent,
        context: 'Chinese Zodiac V2 year-pillar reading. ' + signalString() + '. Package: ' + pk.t + '. Interpret only these zodiac facts.',
        signals: signalString(),
        cards: signalString(),
        spread: 'Year pillar: animal, element, polarity',
        scope: pk.t + ' report for a ' + sg.full + ' focused on ' + intentTitle().toLowerCase() + '.',
        confidence: 'Symbolic Chinese zodiac guidance for reflection, not a factual or guaranteed prediction.',
        tool: PAGE,
        checkoutProperties: {
          '_Presentation Variant': 'chinese-zodiac-v2',
          '_Package': pk.t,
          '_Zodiac Sign': sg.full,
          '_Birth Date': dobText(),
          '_Partner Sign': s.partner ? s.partner.full : '',
          '_Current Zodiac Year': CZ.pol + ' ' + CZ_NAME + ' ' + CZ.zy
        }
      });
      if (typeof api.setPreviewAuthorization === 'function') api.setPreviewAuthorization({ previewToken: '', transportFallback: false });
      if (typeof api.setCheckoutPending === 'function') api.setCheckoutPending(false);
    } catch (_) {}
  }
  function startCheckout(via) {
    track('zc_v2_checkout_started', { tier: RAIL_TIERS[s.pkg], via: via, intent: s.intent });
    var api = window.DeckauraDeepReading;
    var st = document.querySelector('[data-rv2-checkout-status]');
    if (!api || typeof api.checkoutNow !== 'function') {
      if (st) { st.textContent = 'Checkout is warming up, please tap again in a second.'; st.style.display = 'block'; }
      return;
    }
    enableRail();
    try { api.setTier(RAIL_TIERS[s.pkg] || 'deeper'); } catch (_) {}
    /* checkoutNow fiyat hazir degilken sessizce dusebiliyor (hizli tiklama);
       hazir olana kadar kisa araliklarla bekle, sonra TEK sefer ates et. */
    var tries = 0;
    (function go() {
      tries += 1;
      var ready = true;
      try { ready = typeof api.isPriceReady !== 'function' || api.isPriceReady(); } catch (_) {}
      if (!ready && tries < 9) {
        if (st) { st.textContent = 'Preparing your secure checkout…'; st.style.display = 'block'; st.style.color = '#C9A96A'; }
        setTimeout(go, 700);
        return;
      }
      if (st && ready) st.style.display = 'none';
      if (!ready && st) { st.textContent = 'Checkout is warming up, please tap the button again.'; st.style.display = 'block'; }
      try { api.checkoutNow(); } catch (_) {}
    })();
  }

  /* ------------ flow ------------ */
  function calc() {
    if (!s.m || !s.d || !s.y) {
      s.err = 'Select a month, a day and a year to calculate your sign.';
      render(); return;
    }
    var dim = new Date(+s.y, +s.m, 0).getDate();
    if (+s.d > dim) {
      s.err = MONTHS[+s.m - 1] + ' ' + s.y + ' has only ' + dim + ' days. Check the day.';
      render(); return;
    }
    var sg = sign(+s.y, +s.m, +s.d);
    s.err = ''; s.phase = 'calculating'; s.editing = false; s.live = '';
    s.server = null; s.readingId = 'zc-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    render();
    if (calcTimer) clearTimeout(calcTimer);
    calcTimer = setTimeout(function () {
      s.phase = 'result';
      s.live = 'Your Chinese zodiac is ' + sg.full + '.';
      /* Paket + ucretsiz icgoru bolumu sadece niyet secilince aciliyordu (offerOn = done && intent);
         14 gunde ~7.8K oturumdan 6 ziyaretci o adima ulasti. Varsayilan niyetle teklif sonucun
         hemen altinda gorunur; ziyaretci niyeti yine degistirebilir. */
      if (!s.intent) { s.intent = INTENTS[0].k; track('zc_v2_intent_defaulted', { intent: s.intent }); }
      render();
      track('zc_v2_result', { sign: sg.full, cutoff: sg.before });
      setTimeout(function () { scrollScreen('Result reveal', 70); }, 60);
      if (s.intent) { enableRail(); scheduleInsight(); }
    }, 700);
    track('zc_v2_calc', {});
  }
  function download() {
    var sg = mySign();
    if (!sg) return;
    try {
      var cv = document.createElement('canvas');
      cv.width = 840; cv.height = 1040;
      var ctx = cv.getContext('2d');
      var g = ctx.createLinearGradient(0, 0, 0, 1040);
      g.addColorStop(0, '#141A32'); g.addColorStop(1, '#0A0E1C');
      ctx.fillStyle = g; ctx.fillRect(0, 0, 840, 1040);
      ctx.strokeStyle = 'rgba(201,169,106,0.45)'; ctx.lineWidth = 2;
      ctx.strokeRect(26, 26, 788, 988);
      ctx.fillStyle = '#C9A96A';
      ctx.font = '600 26px "Public Sans", sans-serif';
      ctx.fillText('DECKAURA · CHINESE ZODIAC', 70, 110);
      ctx.fillStyle = 'rgba(245,240,232,0.9)';
      ctx.font = '300 210px Spectral, serif';
      ctx.fillText(sg.a.c, 70, 400);
      ctx.fillStyle = '#F5F0E8';
      ctx.font = '400 84px Spectral, serif';
      ctx.fillText(sg.full, 70, 560);
      ctx.fillStyle = '#E4E0EC';
      ctx.font = '400 34px "Public Sans", sans-serif';
      ctx.fillText('Element ' + sg.e.n + ' · ' + sg.pol + ' · zodiac year ' + sg.zy, 70, 640);
      ctx.fillText(sg.a.gift.charAt(0).toUpperCase() + sg.a.gift.slice(1), 70, 700);
      ctx.strokeStyle = 'rgba(245,240,232,0.2)';
      ctx.beginPath(); ctx.moveTo(70, 900); ctx.lineTo(770, 900); ctx.stroke();
      ctx.fillStyle = '#D6D2E0';
      ctx.font = '400 28px "Public Sans", sans-serif';
      ctx.fillText('Compare your sign with mine · deckaura.com', 70, 960);
      var a2 = document.createElement('a');
      a2.download = 'deckaura-chinese-zodiac-' + sg.a.n.toLowerCase() + '.png';
      a2.href = cv.toDataURL('image/png');
      a2.click();
      track('zc_v2_share_download', { sign: sg.full });
    } catch (_) {}
  }

  /* ------------ events ------------ */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var dl = t.closest('[data-zc-download]');
    if (dl) { ev.preventDefault(); download(); return; }
    var fq = t.closest('[data-zc-faq]');
    if (fq) {
      var open = fq.getAttribute('aria-expanded') === 'true';
      var box = fq.parentElement.querySelector('.zc-faq-a');
      var arrow = fq.querySelector('span[aria-hidden]');
      fq.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (box) box.style.display = open ? 'none' : 'block';
      if (arrow) arrow.style.transform = open ? 'rotate(0deg)' : 'rotate(180deg)';
      return;
    }
    var act = t.closest('[data-rv2-act]');
    if (act && act.closest('[data-zc-scope]')) {
      var a = act.getAttribute('data-rv2-act');
      if (a === 'calc') { ev.preventDefault(); calc(); }
      else if (a === 'edit') { s.editing = true; render(); }
      else if (a === 'method') { s.method = !s.method; render(); }
      else if (a === 'explore') { ev.preventDefault(); scrollScreen('Intent selector', 70); }
      else if (a === 'shareopen') { s.share = true; render(); track('zc_v2_share_open', {}); }
      else if (a === 'shareclose') { s.share = false; render(); }
      else if (a === 'sampleopen') { s.sample = true; render(); track('zc_v2_sample_open', {}); }
      else if (a === 'sampleclose') { s.sample = false; render(); }
      else if (a === 'partner') {
        if (!s.pm || !s.pd || !s.py) return;
        var dim = new Date(+s.py, +s.pm, 0).getDate();
        if (+s.pd > dim) return;
        s.partner = sign(+s.py, +s.pm, +s.pd);
        render();
        track('zc_v2_partner', { rhythm: mySign() ? rhythmOf(AN.indexOf(mySign().a), AN.indexOf(s.partner.a)) : '' });
        enableRail(); scheduleInsight();
      }
      else if (a === 'sticky') { ev.preventDefault(); startCheckout('sticky_bar'); }
      return;
    }
    var item = t.closest('[data-rv2-item]');
    if (!item || !item.closest('[data-zc-scope]')) return;
    var listName = item.getAttribute('data-rv2-item');
    var idx = Number(item.getAttribute('data-rv2-idx'));
    var sub = t.closest('[data-rv2-subact]');
    if (listName === 'intents') {
      var first = !s.intent;
      s.intent = INTENTS[idx].k;
      s.chip = null; s.partner = null; s.server = null;
      render();
      track('zc_v2_intent', { intent: s.intent });
      if (first) setTimeout(function () { scrollScreen('Free insight and packages', 150); }, 90);
      enableRail(); scheduleInsight();
    }
    else if (listName === 'chips') {
      var chipSet = s.intent ? CHIPS[s.intent] : null;
      if (!chipSet) return;
      var label = chipSet.items[idx];
      s.chip = s.chip === label ? null : label;
      render();
      track('zc_v2_chip', { chip: s.chip || 'cleared' });
      enableRail(); scheduleInsight();
    }
    else if (listName === 'pkgs') {
      s.pkg = idx;
      if (sub && sub.getAttribute('data-rv2-subact') === 'buy') {
        render();
        ev.preventDefault();
        startCheckout('package_cta');
        return;
      }
      track('zc_v2_tier_selected', { tier: RAIL_TIERS[idx] });
      render();
      enableRail();
    }
  });
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.matches || !t.matches('[data-rv2-sel]')) return;
    var key = t.getAttribute('data-rv2-sel');
    s[key] = t.value;
    if (key === 'm' || key === 'd' || key === 'y') s.err = '';
    render();
  });
  window.addEventListener('resize', function () {
    var w = window.innerWidth;
    if (Math.abs(w - s.w) > 4) { s.w = w; render(); }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && (s.sample || s.share)) { s.sample = false; s.share = false; render(); }
  });

  function boot() {
    render();
    track('zc_v2_page_ready', {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
